import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import unescapedText from 'I18n/utils/unescapedText';
import UIApplication from 'UIComponents/app/UIApplication';
import UIBox from 'UIComponents/layout/UIBox';
import MarketingNav, { MARKETING_NAV_LANGUAGES, getMarketingNavLanguagesContent } from 'marketplace-ui-common/components/MarketingNav';
import * as AppContext from 'ecosystem-marketplace-solutions-base/constants/AppContext';
import { getAppShortlink, getFullLocationPathname // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message
} from 'ecosystem-marketplace-solutions-base/utils/urls'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message

import { getTrackingParams } from 'ecosystem-marketplace-solutions-base/selectors/app'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message

import { useShortlinkParams } from 'ecosystem-marketplace-core/hooks/useShortlinkParams';

const getI18nKey = key => `ecosystem-marketplace-solutions-ui.publicApplication.${key}`;

const StyledUIApplication = styled(UIApplication).withConfig({
  displayName: "Application__StyledUIApplication",
  componentId: "sc-1qixeph-0"
})(["display:flex;flex-direction:column;"]);
const StyledMainContent = styled(props => /*#__PURE__*/_jsx(UIBox, Object.assign({}, props, {
  grow: 1,
  shrink: 1
}))).withConfig({
  displayName: "Application__StyledMainContent",
  componentId: "sc-1qixeph-1"
})(["min-height:100vh;"]);
export default function Application({
  children
}) {
  const location = useLocation();
  const trackingParams = useSelector(getTrackingParams);
  const shortlinkParams = useShortlinkParams(trackingParams);
  const hydratedLanguagesContent = useMemo(() => {
    return getMarketingNavLanguagesContent(Object.keys(MARKETING_NAV_LANGUAGES).reduce((final, languageCode) => {
      final[languageCode] = `${getFullLocationPathname(location.pathname, AppContext.PUBLIC, languageCode)}${location.search}`;
      return final;
    }, {}));
  }, [location]);
  const headerContentBlob = useMemo(() => {
    const contactText = unescapedText(getI18nKey('header.contactText'));
    const contactUrl = 'https://offers.hubspot.com/contact-sales';
    const ctaText = unescapedText(getI18nKey('header.ctaText')); // TODO attribution?

    const ctaUrl = 'https://www.hubspot.com/products/get-started';
    return {
      upperNavContent: {
        loginUrl: getAppShortlink(location.pathname, shortlinkParams),
        loginText: unescapedText(getI18nKey('header.loginText')),
        ctaText,
        ctaUrl,
        regionalDropdownContent: {
          contactText,
          contactUrl,
          languagesContent: hydratedLanguagesContent
        }
      },
      mobileNavContent: {
        contactText,
        contactUrl,
        ctaText,
        ctaUrl,
        languagesContent: hydratedLanguagesContent,
        searchPlaceholder: unescapedText(getI18nKey('header.searchPlaceholder'))
      }
    };
  }, [hydratedLanguagesContent, location, shortlinkParams]);
  return /*#__PURE__*/_jsx(StyledUIApplication, {
    name: "ecosystem-marketplace-solutions-public-ui",
    children: /*#__PURE__*/_jsx(MarketingNav, {
      enableConvertFlag: true,
      headerContentBlob: headerContentBlob,
      children: /*#__PURE__*/_jsx(StyledMainContent, {
        children: children
      })
    })
  });
}